import styled from '@emotion/styled';
import { pressActionEffect } from '@styles/mixin';

import LocationIcon from './LocationIcon';

interface Props {
    onClick?: () => void;
}

/** 지도 우측 하단의 내 위치로 이동 버튼 */
function LocationButton({ onClick }: Props) {
    return (
        <Base type='button'
            aria-label='내 위치 확인'
            onClick={onClick}>
            <LocationIcon/>
        </Base>
    );
}

const Base = styled.button`
    align-items: center;
    background-color: var(--color-white);
    border-radius: var(--radius-m);
    bottom: var(--spacing-4);
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    height: 40px;
    justify-content: center;
    padding: var(--spacing-2);
    position: absolute;
    right: var(--spacing-4);
    width: 40px;
    z-index: 2;
    ${pressActionEffect}
`;

export default LocationButton;
